import { get, post } from "./api";

export async function getCurrentCanvaMe() {
  const { data } = await get({ path: `/apps/canva/me` });
  return data;
}

export async function getDesigns(
  query?: string,
  limit?: number,
) {
  const { data } = await get({ path: `/apps/canva/designs?query=${query || ""}&limit=${limit || 100}` });
  return data;
}

export async function getDesign(designId: string) {
  const { data } = await get({ path: `/apps/canva/designs/${designId}` });
  return data;
}

export async function getDesignPages(designId: string) {
  const { data } = await get({ path: `/apps/canva/designs/${designId}/pages` });
  return data;
}

export const createExportJob = async (designId: string, page: number): Promise<any> => {
  const response = await post({
    path: `/apps/canva/designs/${designId}/exports`,
    data: {
      format: {
        type: "png",
        pages: [page],
      },
    },
  });
  return response.data;
}

export const getExportJob = async (exportId: string): Promise<any> => {
  const response = await get({
    path: `/apps/canva/exports/${exportId}`,
  });
  return response.data;
}

export const getExportFormats = async (designId: string): Promise<any> => {
  const response = await get({
    path: `/apps/canva/designs/${designId}/export-formats`,
  });
  return response.data;
}
